<template>
    <div class="footer">
      <!-- <p>北京中录国际-电信与信息服务业务经营许可证:<a href="http://www.zlvod.cn/pdf/icp.pdf" class="mleft" target="_blank">京ICP证070705号</a>
     <span class="l20">北京中录国际SP证:<a href="http://www.zlvod.cn/pdf/sp.pdf" class="mleft" target="_blank">B2-20160073</a></span> -->
     <!-- <span class="l20">（新）中录国际网络文化经营许可证:<a href="http://www.zlvod.cn/pdf/wenhua.pdf" class="mleft" target="_blank">京网文[2019]1296-131号</a></span> -->
     <p><span class="l20">信息网络传播视听节目许可证:<a href="http://www.zlvod.cn/pdf/shiting.pdf" class="mleft" target="_blank">0110525</a></span></p>
    <p>Copyright© www.zlvod.com. All rights reserved.北京中录国际文化传播有限公司 版权所有 </p>
      <p>
        <a href="https://beian.miit.gov.cn/" target="_blank"><span class="l20">京ICP备10015101号-4 </span></a>
        <!-- <span class="l20"><a href="https://beian.mps.gov.cn/#/query/webSearch?code=11011402054105" class="mleft" target="_blank">京公网安备11010502055725号</a></span> -->
      </p>
    </div>
</template>

<script>
  export default {
      data() {
        return {
          input: ''
        };
      },
      mounted() {
      },
      methods: {
         homePage(){
           this.$router.push({path: '/index'});
         },
      }
    };
</script>

<style>
.footer{
  text-align: center;
  color: #ffffff;
}
.mleft{
  margin-left:10px;
}
.l20{
  margin-left:20px;
}
</style>



// WEBPACK FOOTER //
// src/page/footer/index.vue